import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

const LoadingBox = () => {
  return (
    <Grid container direction="row" justify="center" alignItems="stretch">
      <Grid item container justify="center" alignItems="stretch">
        <CircularProgress id="loadingBox" size={40} color="primary" />
      </Grid>
    </Grid>
  );
};
export default LoadingBox;
